
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/komodo-defi-framework/api/legacy/my_balance",
      function () {
        return require("private-next-pages/docs/komodo-defi-framework/api/legacy/my_balance/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/komodo-defi-framework/api/legacy/my_balance"])
      });
    }
  